import React, { useState } from "react";
import deleteIcon from "../../../../assets/images/button/deleteIcon.svg";
import deleteIconDark from "../../../../assets/images/button/deleteIconDark.svg";
import useTheme from "hooks/observer";
import "./SpaceCategoriesCard.scss";

export default function SpaceCategoriesCard({ categories = [], selectedCategory, onSelectCategory, onAddCategory, onSetCategoryEnabled, onDeleteCategory }) {
  const theme = useTheme();
  const [adding, setAdding] = useState(false);
  const [newName, setNewName] = useState("");

  // Theme-aware delete icon
  const getDeleteIcon = () => {
    return theme === "dark" ? deleteIconDark : deleteIcon;
  };

  const submitNew = () => {
    if (!onAddCategory) return;
    const trimmed = newName.trim();
    // Validate space name length (max 80 characters)
    if (trimmed.length > 80) {
      return; // Don't submit if exceeds limit
    }
    // Validate space name with regex: allow only alphanumeric and '.', '-', '_', '@', ','
    const spaceNameRegex = /^[a-zA-Z0-9.\-_@,]*$/;
    if (trimmed && !spaceNameRegex.test(trimmed)) {
      return; // Don't submit if doesn't match regex
    }
    const ok = onAddCategory(newName);
    if (ok) {
      setNewName("");
      setAdding(false);
    }
  };
  //  TODO: Replace keys for listing space objects with uuids instead of names.

  return (
    <div className="Card">
      <div className={`CardHeader ${adding ? 'adding' : ''}`}>
        <h3>My Space </h3>
        {!adding ? (
          <button className="PrimarySm" onClick={() => setAdding(true)}>Add</button>
        ) : (
          <div className="InlineAdd">
            <input
              autoFocus
              value={newName}
              placeholder="Space name"
              maxLength={80}
              onChange={(e) => {
                // Allow only alphanumeric and '.', '-', '_', '@', ','
                const spaceNameRegex = /^[a-zA-Z0-9.\-_@,]*$/;
                const value = e.target.value;
                if (spaceNameRegex.test(value)) {
                  setNewName(value);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") submitNew();
                if (e.key === "Escape") { setAdding(false); setNewName(""); }
              }}
            />
            <button onClick={submitNew}>Add</button>
            <button onClick={() => { setAdding(false); setNewName(""); }}>Cancel</button>
          </div>
        )}
      </div>
      <div className="CardBody">
        <ul className="List">
          {categories.map(({ name, enabled }) => (
            <li
              key={name}
              className={name === selectedCategory ? "activeItem" : ""}
              style={{
                background: name === selectedCategory ? "var(--fill-brand-light)" : undefined,
                fontWeight: name === selectedCategory ? 600 : 400,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "8px"
              }}
            >
              <span
                className="ItemName"
                style={{
                  cursor: enabled ? "pointer" : "not-allowed",
                  flex: 1,
                  minWidth: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  opacity: enabled ? 1 : 0.5,
                  pointerEvents: enabled ? "auto" : "none"
                }}
                onClick={() => enabled && onSelectCategory && onSelectCategory(name)}
                title={name}
              >
                {name}
              </span>

              <img
                src={getDeleteIcon()}
                alt="Delete"
                style={{
                  width: "16px",
                  height: "16px",
                  cursor: "pointer",
                  opacity: 0.7,
                  transition: "opacity 0.2s",
                  flexShrink: 0
                }}
                onMouseEnter={(e) => e.target.style.opacity = "1"}
                onMouseLeave={(e) => e.target.style.opacity = "0.7"}
                onClick={(e) => {
                  e.stopPropagation();
                  if (onDeleteCategory) {
                    onDeleteCategory(name);
                  }
                }}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
